import { useState, useLayoutEffect } from "react";

export default function useCheckIfMobile(mobileWidth = 900) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < mobileWidth);

  useLayoutEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < mobileWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [mobileWidth]);

  return isMobile;
}
